import React from 'react';
import { Button, ButtonType } from '@redreamerlab/uikit';
import { Row, StyledIconImg } from '@styles/common';
import { gridiconsNoticeIcon } from '@styles/imgMapping';
import { AppError } from '@/providers/pageProvider';
import { ConnectButton } from '../../pages/Home/ConnectButton';
import { StyledCustomRow, StyledMessage, StyledModal, StyledTitle } from './Styles';

type Props = {
  title: string;
  opened: boolean;
  onClose: () => void;
  error: AppError;
};

const ErrorModal = ({ title, opened, onClose, error }: Props) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <StyledModal hasBackDrop opened={opened} onClose={handleClose} width="450" disabledCloseButton>
      <Row justify="space-between" align="flex-start">
        <div>
          <StyledTitle>{title}</StyledTitle>
          <StyledMessage>{error?.message || error?.code || error?.error}</StyledMessage>
        </div>
        <StyledIconImg src={gridiconsNoticeIcon} alt="error" width="40px" />
      </Row>
      <StyledCustomRow justify="center">
        <ConnectButton name="OK" onClick={handleClose} />
      </StyledCustomRow>
    </StyledModal>
  );
};

export default ErrorModal;
